(() => {
  const initHeroFloorMats = (scope = document) => {
    if (typeof Swiper === 'undefined') return;

    const slider = scope.querySelector('.hero-floor-mats__slider');
    if (!slider || slider.classList.contains('swiper-initialized')) return;

    new Swiper(slider, {
      loop: true,
      slidesPerView: 1,
      navigation: {
        nextEl: slider.querySelector('.hero-floor-mats__button--next'),
        prevEl: slider.querySelector('.hero-floor-mats__button--prev'),
      },
      pagination: {
        el: slider.querySelector('.hero-floor-mats__pagination'),
        clickable: true,
      },
      speed: 600,
      a11y: true,
    });
  };

  document.addEventListener('DOMContentLoaded', () => initHeroFloorMats(document));
  document.addEventListener('shopify:section:load', (event) => initHeroFloorMats(event.target));
})();
